import * as sessionObjects from '../../js/resources/SessionObjects.js';

export class ConfigUtils {

    static getCountryCode (routeEvent) {

        let tokenData = sessionObjects.CURRENT_USER.get('token').get('decoded');

        return ((tokenData && tokenData.country) ? tokenData.country : routeEvent.routeNamedArgs.countryCode);
    }

    static getCountryConfig (config, routeEvent) {

        let countryCode = ConfigUtils.getCountryCode(routeEvent);

        return _.extend({}, config.defaults, (countryCode ? config[countryCode] : {}));
    }
}


// WEBPACK FOOTER //
// ./shared/utils/ConfigUtils.js